import PropTypes from 'prop-types';
import { m } from 'framer-motion';
import { useEffect } from 'react';
// @mui
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
// hooks
// import { useMockedUser } from 'src/hooks/use-mocked-user';
// assets
import { ForbiddenIllustration } from 'src/assets/illustrations';
// components
import { MotionContainer, varBounce } from 'src/components/animate';

// ----------------------------------------------------------------------
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from 'src/auth/hooks';
import { paths } from 'src/routes/paths';

const resolveMenuPath = (pathString) => {
  if (!pathString) return null;
  try {
    const parts = pathString.trim().split('.');
    let result = { paths };
    for (let i = 1; i < parts.length; i++) {
      result = result[parts[i]];
      if (result === undefined) return null;
    }
    return typeof result === 'string' ? result : null;
  } catch {
    return null;
  }
};

export default function RoleBasedGuard({ children, sx }) {
  const { access, loading } = useSelector((state) => state.access);
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading && !access && location.pathname === '/dashboard' && user?.menu?.length > 0) {
      const sortedMenu = [...user.menu].sort((a, b) => {
        if (a.parent_id !== b.parent_id) return a.parent_id - b.parent_id;
        return a.id - b.id;
      });
      const firstAllowed = sortedMenu.find(
        (item) => item.parent_id === 0 && (item.read_access === 1 || item.read_access === true)
      );
      if (firstAllowed?.path) {
        const resolvedPath = resolveMenuPath(firstAllowed.path);
        if (resolvedPath) {
          navigate(resolvedPath, { replace: true });
          return;
        }
      }
    }
  }, [loading, access, location.pathname, user, navigate]);

  if (loading) {
    return null;
  }

  return access ?
      <>
        {children}
      </>:
    (
      <Container component={MotionContainer} sx={{ textAlign: 'center', ...sx }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Permission Denied
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            You do not have permission to access this page
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration
            sx={{
              height: 260,
              my: { xs: 5, sm: 10 },
            }}
          />
        </m.div>
      </Container>
    );
}

RoleBasedGuard.propTypes = {
  children: PropTypes.node,
  hasContent: PropTypes.bool,
  roles: PropTypes.arrayOf(PropTypes.string),
  sx: PropTypes.object,
};
